"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import _ from "lodash";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
import Question from "@/components/Question.vue";
import { Debounce } from "vue-debounce-decorator";
import API from "@ym-framework/api-utils";
import DistributionDialog from "@/components/dialog/DistributionDialog.vue";
import GridSelector from "@/components/dialog/GridSelector.vue";
let AddInprogressShopsDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.dialog = new UiDialogController();
    // base.auth.pro
    // 店铺列表
    this.gridController = new GridController(
      // new APIDataSource("api://base.auth.kv.shops/v1/shops")
      new APIDataSource("api://base.auth.pro/v1/shops")
    );
    this.searchShop = "";
    this.selectPlatform = "";
    this.selectGroup = "";
    this.selectedDatas = [];
    this.shopselectLock = false;
    this.groupList = {};
    this.platformList = {};
    this.selectedLimit = 0;
    this.limitAll = 0;
    this.usedLimit = 0;
    this.showSelectedLimit = false;
    this.searchData = {
      search: {
        name: "",
        ebusiness_ids: "",
        group_id: ""
      }
    };
    this.loading = false;
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      try {
        this.gridController.pagePosition = "dialog";
        this.gridController.size = true;
        this.gridController.on("searched", (item) => {
          this.byShopcheckItem();
        });
      } catch (error) {
        console.log(error);
      }
    });
  }
  open(datas, selectedLimit) {
    return __async(this, null, function* () {
      try {
        this.loading = true;
        this.searchShop = "";
        this.selectPlatform = "";
        this.selectGroup = "";
        this.searchData.search.name = "";
        this.searchData.search.ebusiness_ids = "";
        this.searchData.search.group_id = "";
        this.selectedDatas = [];
        if (this._byShopGridSelector) {
          this._byShopGridSelector.clear();
        }
        this.gridController.query.params = null;
        this.dialog.visible = true;
        yield this.getPlatforms();
        yield this.getGroups();
        this.gridController.query.params = {
          type: "SHOW"
        };
        yield this.gridController.search();
        if (selectedLimit) {
          this.limitAll = selectedLimit.quota;
          this.usedLimit = selectedLimit.usedQuota;
          this.showSelectedLimit = true;
          this.selectedLimit = this.limitAll - this.usedLimit;
        } else {
          this.showSelectedLimit = false;
        }
        if (datas) {
          this.shopselectLock = true;
          setTimeout(() => {
            this.editSelectedItems(datas);
          }, 10);
        } else {
          this.selectedDatas = [];
        }
        this.shopselectLock = false;
        this.$nextTick(() => {
          this._byShopGridSelector.setOptSpan(16, 8);
          if (datas) {
            for (let data of datas) {
              let item = _.find(this.gridController.result.datas, {
                id: data.id
              });
              if (item !== void 0) {
                this._multipleTable.toggleRowSelection(item, true);
              }
            }
          }
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    });
  }
  clearSearchParams() {
    return __async(this, null, function* () {
      try {
        this.searchData.search.name = "";
        this.searchData.search.ebusiness_ids = "";
        this.searchData.search.group_id = "";
        this.selectPlatform = "";
        this.selectGroup = "";
        this.searchShop = "";
        this.gridController.query.params = null;
        yield this.gridController.search();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  getGroups() {
    return __async(this, null, function* () {
      try {
        this.groupList = null;
        const response = yield API.get(
          "api://base.auth.pro/v1/groups",
          {
            params: {
              type: "SHOP"
            }
          }
        );
        if (response.data) {
          this.groupList = response.data.datas;
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  getPlatforms() {
    return __async(this, null, function* () {
      try {
        this.platformList = null;
        const response = yield API.get(`api://base.auth/api/v7/orgs/ebusinesses`);
        if (response.data) {
          this.platformList = response.data.datas;
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  byShopChanged(data) {
    let rows = _.differenceWith(
      this.selectedDatas,
      data,
      (selectData, data2) => selectData.id == data2.id
    );
    this.shopselectLock = true;
    if (rows) {
      for (const row of rows) {
        const selectedItem = _.find(this.gridController.result.datas, {
          id: row.id
        });
        if (selectedItem) {
          this._multipleTable.toggleRowSelection(selectedItem, false);
          this.selectedDatas = this.selectedDatas.filter(
            (data2) => data2.id !== row.id
          );
        }
      }
    }
    this.shopselectLock = false;
  }
  byShopcheckItem() {
    var _a;
    let selectDatas = (_a = this._byShopGridSelector) == null ? void 0 : _a.getAll();
    let rows = _.intersectionWith(
      this.gridController.result.datas,
      selectDatas,
      (data, selectData) => selectData.id == data.id
    );
    this.shopselectLock = true;
    if (rows) {
      for (const row of rows) {
        this._multipleTable.toggleRowSelection(row, true);
      }
    }
    this.shopselectLock = false;
  }
  changeGroup() {
    return __async(this, null, function* () {
      this.searchData.search.group_id = `group==${this.selectGroup};`;
      yield this.searchAllData();
    });
  }
  changePlatform() {
    return __async(this, null, function* () {
      this.searchData.search.ebusiness_ids = `platforms=in=("${this.selectPlatform}");`;
      yield this.searchAllData();
    });
  }
  searchByShopName(searchStr) {
    return __async(this, null, function* () {
      if (searchStr !== null && searchStr !== "") {
        this.searchData.search.name = `name=like="${searchStr}";`;
      }
      if (searchStr === null || searchStr === "") {
        this.searchData.search.name = "";
      }
      yield this.searchAllData();
    });
  }
  searchAllData() {
    return __async(this, null, function* () {
      let searchStr = this.searchData.search.name + this.searchData.search.ebusiness_ids + this.searchData.search.group_id;
      this.gridController.query.params = { type: "SHOW", search: searchStr };
      this.gridController.query.current = 1;
      yield this.gridController.search();
    });
  }
  confirmButton(datas) {
    try {
      let data = {
        selectedShops: this.selectedDatas
      };
      this.$emit("changeEnvShops", data);
      this.close();
    } catch (error) {
    }
  }
  deleteSelected(item) {
  }
  editSelectedItems(items) {
    try {
      for (const item of items) {
        const _item = {
          id: item["id"],
          label: `${item["name"]}`
        };
        let _dataitem = _.find(this.selectedDatas, { id: item.id });
        if (_dataitem === void 0) {
          let selectItem = {
            id: item.id,
            label: item.name
          };
          this.selectedDatas.push(selectItem);
        }
        this._byShopGridSelector.add(_item);
      }
    } catch (error) {
      console.log(error);
    }
  }
  selectable(row, index) {
    if (this.showSelectedLimit) {
      if (this.selectedLimit === 0) {
        return false;
      }
      let _data = this._byShopGridSelector.getAllNew();
      if (_data.length >= this.selectedLimit) {
        for (const item of _data) {
          if (item.id === row.id) {
            return true;
          }
        }
        return false;
      }
      if (_data.length === 0 || _data.length < this.selectedLimit) {
        return true;
      }
      return false;
    } else {
      return true;
    }
  }
  selectItems(items) {
    try {
      if (!this.shopselectLock) {
        let unSelectData = _.differenceWith(
          this.gridController.result.datas,
          items,
          _.isEqual
        );
        for (const item of items) {
          const _item = {
            id: item["id"],
            label: `${item["name"]}`
          };
          let _dataitem = _.find(this.selectedDatas, { id: item.id });
          if (_dataitem === void 0) {
            if (this.showSelectedLimit) {
              if (this.selectedDatas.length >= this.selectedLimit) {
                this.$message.error(this.$t("add_inprogress_shops.dialog.selected_limit_error"));
                return;
              }
            }
            let selectItem = {
              id: item.id,
              label: item.name
            };
            this.selectedDatas.push(selectItem);
          }
          this._byShopGridSelector.add(_item);
        }
        for (const item of unSelectData) {
          const _item = {
            id: item["id"],
            label: `${item["name"]}`
          };
          this.selectedDatas = this.selectedDatas.filter(
            (data) => data.id !== item.id
          );
          this._byShopGridSelector.del(_item);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
  close() {
    this.dialog.visible = false;
  }
};
__decorateClass([
  Ref("multipleTable")
], AddInprogressShopsDialog.prototype, "_multipleTable", 2);
__decorateClass([
  Ref("byShopGridSelector")
], AddInprogressShopsDialog.prototype, "_byShopGridSelector", 2);
__decorateClass([
  Debounce(500)
], AddInprogressShopsDialog.prototype, "changeGroup", 1);
__decorateClass([
  Debounce(500)
], AddInprogressShopsDialog.prototype, "changePlatform", 1);
__decorateClass([
  Debounce(500)
], AddInprogressShopsDialog.prototype, "searchByShopName", 1);
AddInprogressShopsDialog = __decorateClass([
  Component({
    components: {
      UiGrid,
      UiDialog,
      Question,
      DistributionDialog,
      GridSelector
    }
  })
], AddInprogressShopsDialog);
export {
  AddInprogressShopsDialog as default
};
